import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const MRODeliverySpeedContainer = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.cornerRadius.medium,
}));

export const CalloutOnlyWrapper = styled.div(({ theme }) => ({
    paddingBottom: theme.spacing.medium,
}));

export const RestaurantListContainer = styled.div(() => ({
    width: "100%",
}));

export const RestaurantItem = styled.div<{
    isFirstItem?: boolean;
    isLastItem?: boolean;
}>(({ theme, isFirstItem, isLastItem }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large}`,
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    borderTop: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,

    ...(isFirstItem && {
        borderTop: "none",
    }),

    ...(isLastItem && {
        borderBottomLeftRadius: theme.cornerRadius.medium,
        borderBottomRightRadius: theme.cornerRadius.medium,
        padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.large}`,
    }),
}));

export const RestaurantImageWrapper = styled.div(({ theme }) => ({
    width: theme.spacing.x10,
    height: theme.spacing.x10,
    marginRight: theme.spacing.x7,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing.x1,
}));

export const RestaurantImage = styled.img(({ theme }) => ({
    width: theme.spacing.x10,
    height: theme.spacing.x10,
    borderRadius: "50%",
    objectFit: "cover",
}));

export const RestaurantTextContainer = styled.div({
    flex: 1,
    display: "flex",
    flexDirection: "column",
});

export const RestaurantNameRow = styled.div({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
});

export const RestaurantName = styled(Text)(({ theme }) => ({
    flex: 1,
    minWidth: 0,
    display: "-webkit-box",
    overflowWrap: "break-word",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginRight: theme.spacing.x3,
}));

export const DeliveryTime = styled(Text)(({ theme }) => ({
    flexShrink: 0,
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",

    "& > *:not(:first-child)": {
        marginLeft: theme.spacing.x2,
    },
}));

export const DeliveryMethodLabel = styled(Text)(({ theme }) => ({
    flex: 1,
    marginTop: theme.spacing.xxxSmall,
}));

export const DeliverySpeedIconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.x3,
}));

export const HalfCardHeader = styled.div(({ theme }) => ({
    display: "flex",
    padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.medium}`,
    alignItems: "center",

    "& > *:not(:first-child)": {
        marginLeft: theme.spacing.small,
    },

    "& > img": {
        borderRadius: "50%",
    },
}));

export const HalfCardSeparator = styled.div(({ theme }) => ({
    padding: `${theme.spacing.small} ${theme.spacing.small} 0 ${theme.spacing.small}`,
    display: "flex",
}));
